/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { forEach } from 'lodash'
import OddsButtonGroup from '@views/Matchup/MatchField/PreMatchPage/MatchBlock/OddsBlock/OddsBlockModal/OddsButtonGroup'
import { observer } from 'mobx-react'
import { MarketTrack, MatchTrack } from '@store/matchupStore'
import { Schema$MarketBlock } from '@protocol/game'
// css
import { CenterWrap } from '@styles/match.style'

interface OddsBlockModalProps {
  className: string
  homeTeamName: string
  awayTeamName: string
  odds: MarketTrack
  pageType?: string
  markets: Schema$MarketBlock[]
  match: MatchTrack
  homeKey: string // lsports 는 아웃컴 고유 아이디, 벳레이더는 아웃컴메타 아이디
  awayKey: string
  oddsBlockType: string
  onClickField: (e) => void
  disabled: boolean
  field: string
  enabledHomeFromViewController?: boolean
  enabledAwayFromViewController?: boolean
  homeOutcomeMetaId: string // 오로지 lsports 를 위해서.
  awayOutcomeMetaId: string
  minimumLiveMatchOutcomeRate: number
}

function OddsBlockModal(props: OddsBlockModalProps) {
  const {
    className,
    odds,
    markets,
    match,
    homeKey,
    awayKey,
    oddsBlockType,
    onClickField,
    disabled,
    field,
    enabledHomeFromViewController,
    enabledAwayFromViewController,
    homeOutcomeMetaId,
    awayOutcomeMetaId,
    minimumLiveMatchOutcomeRate,
  } = props

  const makeHiddenOddsChildren = (): React.ReactElement[] => {
    const hiddenOddsChildren = []
    const { id, matchId } = match
    forEach(markets, (market, index) => {
      hiddenOddsChildren.push(<OddsButtonGroup
        key={`OddsButtonGroup:Row:${id}:${matchId}:${oddsBlockType}:${index}`}
        odds={odds}
        market={market}
        match={match}
        homeKey={homeKey}
        awayKey={awayKey}
        oddsBlockType={oddsBlockType}
        onClickField={onClickField}
        disabled={disabled}
        field={field}
        enabledHomeFromViewController={enabledHomeFromViewController}
        enabledAwayFromViewController={enabledAwayFromViewController}
        tabIndex={index}
        homeOutcomeMetaId={homeOutcomeMetaId}
        awayOutcomeMetaId={awayOutcomeMetaId}
        minimumLiveMatchOutcomeRate={minimumLiveMatchOutcomeRate}
      />)
    })
    return hiddenOddsChildren
  }

  return (
    <CenterWrap className={`top-wrap  ${className}`}>{makeHiddenOddsChildren()}</CenterWrap>
  )
}

export default observer(OddsBlockModal)
